import { Box, Typography } from '@mui/material';
import React from 'react';
import { useSelector } from 'react-redux';
import { I18n } from 'utils/i18n';
import documentModalActions from 'store/app/ui/modals/document/action';
import useActions from 'utils/useActions';
import Modal from '../Modal';
import DownloadButton from './DownloadButton';

const DocumentModal = () => {
  const { isOpen, src, messageText = '', mimeType } = useSelector(state => state.modals.document);
  const documentModal = useActions(documentModalActions);
  const pathWithoutQuery = src?.split('?')[0] || '';
  const isPdf = pathWithoutQuery.toLowerCase().endsWith('.pdf') || mimeType === 'application/pdf';

  if (!src || !isOpen) return null;

  return (
    <Modal isOpen={isOpen} onClose={documentModal.close}>
      {isPdf ? (
        <Box
          sx={{
            maxWidth: 860,
            width: '90vw',
            height: '70vh',
            maxHeight: 'calc(100vh - 250px)',
            position: 'relative',
            '&::before': {
              content: `''`,
              position: 'absolute',
              boxShadow: 'inset 0px -10px 10px -10px rgba(0,0,0,0.5)',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              pointerEvents: 'none',
            },
          }}
        >
          <Box
            component="iframe"
            title="pdf"
            src={src}
            sx={{
              zIndex: 'initial',
              border: 0,
              width: '100%',
              height: '100%',
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: 100,
            minWidth: 400,
            mb: '15px',
            backgroundColor: '#eee',
          }}
        >
          <Typography>{I18n.t('Documents.NoPreview')}</Typography>
        </Box>
      )}
      <Box sx={{ mt: 1 }}>
        <DownloadButton src={src} name={messageText} mimeType={mimeType} />
      </Box>
    </Modal>
  );
};

export default DocumentModal;
